var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.options && _vm.options.length
    ? _c(
        "div",
        { staticClass: "btn-group btn-block", attrs: { role: "group" } },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-block btn-primary btn-lg",
              attrs: {
                "data-submit-button": "true",
                type: "button",
                disabled: _vm.state.loading
              },
              on: { click: _vm.send }
            },
            [
              _vm.state.loading
                ? _c("i", { staticClass: "fas fa-spinner fa-spin pull-right" })
                : _c("span", [_vm._v(_vm._s(_vm.label))])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
            _c("button", {
              staticClass: "btn btn-primary btn-lg dropdown-toggle",
              attrs: {
                type: "button",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dropdown-menu" },
              [
                _c("div", { staticClass: "dropdown-arrow" }),
                _vm._v(" "),
                _vm._l(_vm.options, function(option) {
                  return _c(
                    "a",
                    {
                      key: option.id,
                      staticClass: "dropdown-item",
                      attrs: { href: "javascript:void(0);" },
                      on: { click: () => _vm.sendOption(option) }
                    },
                    [_vm._v(_vm._s(option.label))]
                  )
                })
              ],
              2
            )
          ])
        ]
      )
    : _c(
        "button",
        {
          staticClass: "btn btn-primary btn-lg btn-block",
          attrs: {
            "data-submit-button": "true",
            type: "button",
            disabled: _vm.state.loading
          },
          on: { click: _vm.send }
        },
        [
          _vm.state.loading
            ? _c("b-icon", {
                attrs: { icon: "three-dots", animation: "cylon" }
              })
            : _c("span", [_vm._v(_vm._s(_vm.label))])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }